module.exports = __webpack_public_path__ + "static/media/deloitte_logo.aade7265.jpg";